import { Calendar, DollarSign, TrendingUp, Users } from "lucide-react";

export default function AnalyticsSummary({ summaryMetrics }) {
  return (
    <div className="mb-6 grid grid-cols-1 gap-4 sm:grid-cols-2 sm:gap-6 lg:grid-cols-3">
      <article className="rounded-2xl border border-blue-200 bg-gradient-to-br from-blue-50 to-blue-100 p-4 shadow-lg sm:p-6">
        <div className="mb-2 flex items-center gap-2">
          <div className="rounded-lg bg-blue-500 p-2">
            <Users className="text-white" size={20} />
          </div>
          <p className="text-sm font-semibold uppercase tracking-wide text-blue-700">Total Subscribers</p>
        </div>
        <p className="mb-2 text-2xl font-bold text-blue-900 sm:text-3xl">
          {summaryMetrics.total.toLocaleString()}
        </p>
        <p className="flex justify-between text-xs">
          <span className="font-medium text-blue-600">India:</span>
          <span className="font-bold text-blue-800">{summaryMetrics.national.toLocaleString()}</span>
        </p>
        <p className="flex justify-between text-xs">
          <span className="font-medium text-blue-600">International:</span>
          <span className="font-bold text-blue-800">{summaryMetrics.international.toLocaleString()}</span>
        </p>
      </article>

      <article className="rounded-2xl border border-green-200 bg-gradient-to-br from-green-50 to-emerald-100 p-4 shadow-lg sm:p-6">
        <div className="mb-2 flex items-center gap-2">
          <div className="rounded-lg bg-green-500 p-2">
            <DollarSign className="text-white" size={20} />
          </div>
          <p className="text-sm font-semibold uppercase tracking-wide text-green-700">Total Revenue</p>
        </div>
        <p className="mb-2 text-xl font-bold text-green-900 sm:text-2xl">
          ₹{summaryMetrics.totalRevenueINR.toLocaleString()} / ${summaryMetrics.totalRevenueUSD.toLocaleString()}
        </p>
      </article>

      <article className="rounded-2xl border border-purple-200 bg-gradient-to-br from-purple-50 to-indigo-100 p-4 shadow-lg sm:col-span-2 sm:p-6 lg:col-span-1">
        <div className="mb-2 flex items-center gap-2">
          <div className="rounded-lg bg-purple-500 p-2">
            <TrendingUp className="text-white" size={20} />
          </div>
          <p className="text-sm font-semibold uppercase tracking-wide text-purple-700">Engagement</p>
        </div>
        <div className="grid grid-cols-2 gap-3">
          <div className="rounded-xl bg-white/60 p-3 text-center">
            <Calendar className="mx-auto mb-1 text-purple-600" size={16} />
            <p className="text-lg font-bold text-purple-900">{summaryMetrics.freeTrialUsers.toLocaleString()}</p>
          </div>
          <div className="rounded-xl bg-white/60 p-3 text-center">
            <Users className="mx-auto mb-1 text-red-600" size={16} />
            <p className="text-lg font-bold text-red-900">{summaryMetrics.cancelledRecurring.toLocaleString()}</p>
          </div>
        </div>
      </article>
    </div>
  );
}
